import {Injectable} from "@angular/core";
import { ScriptResources, StyleResources } from './resource/assets-resources.store';

declare var document: any;
@Injectable({ providedIn: 'root' })
export class ResourceManagerService {
  private styles: any = {};
  private scripts: any = {};
  constructor() {
    ScriptResources.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src,
      };
    });
    StyleResources.forEach((style: any) => {
      this.styles[style.name] = {
        loaded: false,
        href: style.src,
      };
    });
  }

  loadStyles(...styles: string[]) {
    styles.forEach((style) => this.createStyle(style));
  }
  createStyle(name: string): any {
    if (!this.styles[name].loaded) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = this.styles[name].href;
      document.head.appendChild(link);
      this.styles[name].loaded = true;
    }
  }
  loadScripts(...scripts: string[]) {
    var promises: any[] = [];
    scripts.forEach((script) => promises.push(this.createScript(script)));
    return Promise.all(promises);
  }
  unloadStyles=(doc: any)=>{
    var styles=Object.keys(this.styles).map(key => ({name: key, value: this.styles[key].href}));
    styles.forEach((style) => {
      var item=doc.head.querySelector(`link[href="${style.value}"`);
      if(item){
        doc.head.removeChild(item);
        this.styles[style.name].loaded = false;
      }
    });
  }
  unloadScript=(doc: any)=>{
    var scripts=Object.keys(this.scripts).map(key => ({name: key, value: this.scripts[key].src}));
    scripts.forEach((script) => {
      var item=doc.body.querySelector(`script[src="${script.value}"`);
      if(item){
        doc.body.removeChild(item);
        this.scripts[script.name].loaded = false;
      }
    });
  }
  unloadResources=(doc: any)=>{
    this.unloadStyles(doc);
    this.unloadScript(doc);
  }
  createScript(name: string) {
    try {
      return new Promise((resolve, reject) => {
        if (this.scripts[name].loaded) {
          resolve({script: name, loaded: true, status: 'Already Loaded'});
        } else {
          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = this.scripts[name].src;
          if (script.readyState) {  // IE
            script.onreadystatechange = () => {
              if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                this.scripts[name].loaded = true;
                resolve({script: name, loaded: true, status: 'Loaded'});
              }
            };
          } else {
            script.onload = () => {
              this.scripts[name].loaded = true;
              resolve({script: name, loaded: true, status: 'Loaded'});
            };
          }
          script.onerror = (error: any) => resolve({script: name, loaded: false, status: 'Loaded'});
          document.body.appendChild(script);
        }
      });
    } catch (error) {
      console.error(`createScript ${name} ${error}`);
    }
  }
}
